module.exports = __webpack_public_path__ + "media/components/assets/icons/logo_footer-5818c1518825385a1278b03ee1672c4f.svg";